import useVuelidate from '@vuelidate/core';
import { createI18nMessage } from '@vuelidate/validators';
import { isValidPhoneNumber } from 'libphonenumber-js';

export function useHelperSignupValidation(params: {
  formData: {
    phoneNumber: string;
    profilePicture: File | null;
  };
  t: (key: string) => string;
}) {
  const withI18nMessage = createI18nMessage({ t: params.t });

  const rules = {
    phoneNumber: {
      validPhoneNumber: withI18nMessage(
        (value: string) => {
          if (!value || value.length === 0) {
            return true;
          }
          return isValidPhoneNumber(value);
        },
        {
          messagePath: () =>
            params.t('generic.phoneNumber') + params.t('validation.valid'),
        }
      ),
    },
    profilePicture: {
      size: withI18nMessage(
        (value: File | null) => {
          if (!(value instanceof File)) {
            return true;
          }
          return value.size < 9 * 1000 * 1000;
        },
        {
          messagePath: () => params.t('validation.pictureSize'),
        }
      ),
    },
  };

  const v$ = useVuelidate(rules, params.formData);

  return {
    v$,
  };
}
